import { render } from "./DealerTabs.vue?vue&type=template&id=2d82c71f&scoped=true"
import script from "./DealerTabs.vue?vue&type=script&lang=js"
export * from "./DealerTabs.vue?vue&type=script&lang=js"

import "./DealerTabs.vue?vue&type=style&index=0&id=2d82c71f&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022759/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d82c71f"]])

export default __exports__